// extracted by mini-css-extract-plugin
export default {"SpiderScheduleFormArgs":"SpiderScheduleForm_SpiderScheduleFormArgs__FrFVy"};